
import { defineComponent } from 'vue';

import useConfig from '@/composables/useConfig';

export default defineComponent({

	name: "App",

	setup() { 
		const config = useConfig()

		return {
			config
		}
	}

})
